<template>
    <div class="tw:flex tw:flex-col tw:gap-4">
        <div class="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:gap-4">
            <div>
                <BaseDateTimePicker
                    id="fecha_sesion"
                    data-cy="fecha_sesion"
                    name="fecha inicio"
                    label="Fecha inicio de la sesión"
                    rules="required"
                    :value="form.fecha_inicio"
                    :min="minFechaInicio"
                    :max="maxFechaInicio"
                    :disabled="loading"
                    :disabled-hint="avisoRangoFechas"
                    @input="onFechaInicioInput"
                />
            </div>

            <div>
                <BaseDateTimePicker
                    id="end_session_date"
                    data-cy="end_session_date"
                    name="fecha fin"
                    label="Fecha fin de la sesión"
                    rules="required"
                    :value="form.fecha_fin"
                    :min="minFechaFin"
                    :max="maxFechaFin"
                    :disabled="loading"
                    :disabled-hint="avisoRangoFechas"
                    @input="val => emit('update:fecha-fin', val)"
                />
            </div>
        </div>

        <div v-if="puedeEditarCierreVenta">
            <BaseDateTimePicker
                id="fecha_cierre_venta"
                data-cy="fecha_cierre_venta"
                name="fecha cierre venta"
                label="Fecha de cierre de venta online"
                :value="form.fecha_cierre_venta"
                :max="maxFechaInicio"
                :disabled="loading"
                @input="val => emit('update:fecha-cierre-venta', val)"
            />
        </div>

        <p
            v-if="rangoSesion"
            class="tw:mt-0 tw:text-xs tw:text-slate-500"
            data-cy="rango-sesion"
        >
            {{ rangoSesion }}
        </p>

        <ToggleSwitch
            v-if="mostrarFechaProvisional"
            id="checkbox_fecha_provisional"
            data-cy="fecha_provisional"
            :value="form.fecha_provisional"
            :disabled="loading"
            @input="val => emit('update:fecha-provisional', val)"
        >
            Fecha y hora provisional
        </ToggleSwitch>

        <BaseInputText
            id="texto"
            data-cy="texto"
            name="texto"
            label="Texto identificativo de la sesión"
            placeholder="Texto"
            :value="form.text"
            :disabled="loading"
            @input="val => emit('update:text', val)"
        />

        <BaseInputText
            id="apertura"
            data-cy="apertura"
            name="apertura"
            label="Apertura de puertas"
            placeholder="Texto"
            :value="form.apertura_puertas"
            :disabled="loading"
            @input="val => emit('update:apertura', val)"
        />
    </div>
</template>

<script setup>
    import BaseDateTimePicker from '@/modules/admin/ui/BaseDateTimePicker.vue';
    import BaseInputText from '@/modules/admin/ui/BaseInputText.vue';
    import ToggleSwitch from '@/modules/admin/ui/ToggleSwitch.vue';

    /**
     * FormSesion — cuerpo del formulario de sesión, compartido por los modales
     * de crear y editar. Presentación pura: recibe `form` (estado en hora de
     * pared, gestionado por useSesionForm en el contenedor) y emite los cambios
     * hacia arriba. No muta props ni conoce la API.
     */
    const props = defineProps({
        form: {
            type: Object,
            required: true,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        minFechaInicio: {
            type: String,
            default: null,
        },
        maxFechaInicio: {
            type: String,
            default: null,
        },
        minFechaFin: {
            type: String,
            default: null,
        },
        maxFechaFin: {
            type: String,
            default: null,
        },
        rangoSesion: {
            type: String,
            default: '',
        },
        avisoRangoFechas: {
            type: String,
            default: '',
        },
        puedeEditarCierreVenta: {
            type: Boolean,
            default: false,
        },
        mostrarFechaProvisional: {
            type: Boolean,
            default: false,
        },
    });

    const emit = defineEmits([
        'update:fecha-inicio',
        'update:fecha-fin',
        'update:fecha-cierre-venta',
        'update:fecha-provisional',
        'update:text',
        'update:apertura',
    ]);

    /**
     * Al cambiar la fecha de inicio, si la de fin quedó por detrás, se limpia:
     * replica el comportamiento del formulario legacy (`clearFecha`).
     */
    const onFechaInicioInput = val => {
        emit('update:fecha-inicio', val);
        if (props.form.fecha_fin && new Date(props.form.fecha_fin) < new Date(val)) {
            emit('update:fecha-fin', '');
        }
    };
</script>
